import { useParams } from 'react-router-dom';

import Loader from '@/components/common/Loader';

import { useCoachActivityLocations } from '@/data/coachActivityLocation';

const Locations = () => {
  const params = useParams();
  const coachActivityLocations = useCoachActivityLocations(
    params.coachActivityId
  );

  if (coachActivityLocations.isLoading && !coachActivityLocations.data) {
    return (
      <div className="h-32 flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  const groupedLocations = coachActivityLocations.data.reduce((acc, item) => {
    const regionName = item.location.region.name; // Accessing the region name from the location object
    if (!acc[regionName]) {
      acc[regionName] = [];
    }
    acc[regionName].push({ id: item.location.id, name: item.location.name }); // Accessing the id and name from the location object
    return acc;
  }, {});

  return (
    <>
      <h2 className="text-2xl font-bold mb-8">Selected Locations</h2>
      <div>
        {Object.keys(groupedLocations).length === 0 ? (
          <p>No locations selected.</p>
        ) : (
          Object.keys(groupedLocations).map((region) => (
            <div key={region} className="mb-4">
              <h3 className="text-md font-medium">{region}</h3>
              <ul className="list-disc pl-5 text-sm">
                {groupedLocations[region].map((location) => (
                  <li key={location.id}>{location.name}</li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default Locations;
